import { toast } from '@/components/toast';
import { getAgent, getAgentByClientKey } from '@/services/api';
import { logger } from '@/services/logger';
import { useQuery } from 'react-query';
import { GET_AGENTS_KEY } from './useGetAgents';

export function useGetAgent(agentId: string, isAuthenticated: boolean, cacheBuster?: number) {
    return useQuery([GET_AGENTS_KEY, agentId, cacheBuster], () => getAgent(agentId, isAuthenticated), {
        enabled: !!agentId && isAuthenticated,
        onError: async (error: any) => {
            logger.error('Could not get agent', { error });
            toast.error({ title: `Could not get agent`, toastId: `agent-get-error` });
        },
    });
}

export function useGetAgentByClientKey(agentId: string, clientKey: string) {
    return useQuery([GET_AGENTS_KEY, agentId, clientKey], () => getAgentByClientKey(agentId, clientKey), {
        enabled: !!agentId && !!clientKey,
        onError: async (error: any) => {
            logger.error('Could not get agent', { error });
            toast.error({ title: `Could not get agent`, toastId: `agent-get-error` });
        },
    });
}
